module.exports = __webpack_public_path__ + "img/one.ae11a2a4.png";